import { ImageThumbnail, ImageThumbnailSizesEnum } from '@acceso/design-system';

type TTableRowThumbnailProps = {
  source?: string;
  className?: string;
};
export function TableRowThumbnail({ source, className }: TTableRowThumbnailProps) {
  return <ImageThumbnail src={source} className={className} size={ImageThumbnailSizesEnum.Xxl} />;
}
